import React from 'react';
import FlexCredentialsActionDelete from './FlexCredentialDeleteAction';

const FlexCredentialActionColumn = ({
	managementCompanyId,
	caregiverId,
	column,
	credentialCode,
	rowData,
	sameCredentialCount
}) => (
	<div className="credential-actions-container">
		{column.renderer === 'edit' &&
			column.actions?.map((action) => {
				// TODO: handle download in the same manner as delete
				if (action.action === 'delete') {
					return (
						<FlexCredentialsActionDelete
							key={action.action}
							actionIdIdentifier={action.identifier}
							managementCompanyId={managementCompanyId}
							caregiverId={caregiverId}
							rowData={rowData}
							credentialType={credentialCode}
							sameCredentialCount={sameCredentialCount}
						/>
					);
				}
				return null;
			})}
	</div>
);

export default FlexCredentialActionColumn;
